"use client";

import Link from "next/link";

export function BackLink({
  href,
  label,
  className = "",
}: {
  href: string;
  label: string;
  className?: string;
}) {
  return (
    <Link
      href={href}
      className={`flex items-center gap-2 text-[var(--sand-10)] group hover:text-[var(--sand-12)] transition-colors duration-150 ease-out text-sm ${className}`}
    >
      <div className="overflow-hidden w-4 h-4 relative">
        <div className="relative">
          <span className="absolute top-0 left-0 transition-all duration-200 group-hover:-translate-x-4 group-hover:-translate-y-4">
            &larr;
          </span>
          <span className="absolute top-0 left-0 transition-all duration-200 translate-x-4 translate-y-4 group-hover:translate-x-0 group-hover:translate-y-0">
            &larr;
          </span>
        </div>
      </div>
      <span>{label}</span>
    </Link>
  );
}
